import React from "react";
import { Text } from "@noom/wax-component-library";

import { NoomAcknowledgementIntakePage } from "../components/NoomAcknowledgementIntakePage";
import { MixpanelTypes } from "../common/types";

export const ConcentrationChangePage: React.FC = () => (
  <NoomAcknowledgementIntakePage
    title="Important Notice: Your Compound is Changing"
    intakeType="CONCENTRATION_CHANGE"
    mixpanelEventName={MixpanelTypes.ConcentrationChangeConfirmed}
    errorTestId="concentration-change-error"
    confirmButtonLabel="Accept"
  >
    <Text size="md" fontWeight="400" marginTop="16px" display="block">
      If prescribed by your doctor, the compounded semaglutide with
      niacinamide is changing. Please read the following information
      carefully.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      What is Different:
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      <strong>Concentration</strong> – The concentration of semaglutide in
      the vial will <strong>CHANGE to 2.5 mg/mL</strong>. Therefore, the
      number of <strong>SYRINGE UNITS</strong> you inject will{" "}
      <strong>INCREASE</strong> to get you to the same dose of medication in
      mg.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      What You Should Do:
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      If your doctor prescribes the new medication, they will send an
      updated treatment plan, please review this carefully to understand
      any changes and how to properly administer your new prescription. Use
      SmartDose in the Noom app to help guide the amount of units you will
      inject during this transition.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      Have Questions?
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      If you have any questions or concerns, please reach out to your care
      coordinator through in-app messaging and we will be happy to assist
      you.
    </Text>
  </NoomAcknowledgementIntakePage>
);
